import { createContext } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastContext = createContext();

export const ToastContextProvider = ({ children }) => {
    return (
        <ToastContext.Provider value={{ toast }}>
            <ToastContainer autoClose={1000} />
            {children}
        </ToastContext.Provider>
    );
};

export default ToastContext;